import React from 'react';
import { useInView } from './useParallax';
import { DiamondDivider, FlameSVG, LotusFlower, SwamiKalasam, OmGlyph } from './svgs';
import './Activities.css';

const activities = [
  {
    icon: <FlameSVG size={56} />,
    title: 'Arunachala Prasadam',
    subtitle: 'Free Sacred Meals',
    description:
      'Round-the-clock free meal distribution to visitors, pilgrims, sadhus, and spiritual practitioners — because no seeker should walk the holy path on an empty stomach.',
    detail: 'Operating 24 hours, 7 days a week along the Girivalam path.',
    accent: '#FF6B00',
  },
  {
    icon: <span className="activity__vedic-icon devanagari">होम</span>,
    title: 'Chandi Homam',
    subtitle: 'Sacred Fire Ritual',
    description:
      'A powerful Vedic fire ceremony invoking Goddess Chandi for the protection and well-being of all. Performed by trained priests with full Vedic rites and offerings.',
    detail: 'Conducted on auspicious days and full-moon evenings.',
    accent: '#C9902A',
  },
  {
    icon: <span className="activity__vedic-icon devanagari">रुद्र</span>,
    title: 'Ekadasi Rudra Homam',
    subtitle: 'Monthly Lunar Ritual',
    description:
      'A deeply sacred Rudra homam performed on Ekadasi — the eleventh day of the lunar fortnight — dedicated to Lord Shiva, invoking grace, purification, and liberation.',
    detail: 'Held every Ekadasi; open to all devotees.',
    accent: '#8B1A1A',
  },
  {
    icon: <LotusFlower size={56} />,
    title: 'Girivalam Seva',
    subtitle: 'Pilgrim Service on the Sacred Circuit',
    description:
      'We set up service points along the 14 km circumambulation of Arunachala, providing food, water, and rest to pilgrims — especially on Karthigai Deepam and monthly Pournami nights.',
    detail: 'Especially active on full-moon nights.',
    accent: '#E8A0BF',
  },
  {
    icon: <OmGlyph size={56} color="#C9902A" />,
    title: 'Sadhu Seva',
    subtitle: 'Supporting Renunciants',
    description:
      'We provide material support, meals, and care to elderly sadhus and renunciants who have dedicated their lives to spiritual pursuit and who depend on community generosity.',
    detail: 'Ongoing care for the spiritual elders of Tiruvannamalai.',
    accent: '#F5C842',
  },
  {
    icon: <SwamiKalasam size={56} />,
    title: 'Arunachala Atmanivas',
    subtitle: 'Spiritual Residential Project',
    description:
      'A serene residential space for spiritual seekers seeking extended stay near Arunachala — offering a community of like-minded souls, simple living, and deep practice.',
    detail: 'For longer-term seekers and retreat participants.',
    accent: '#2D1B5E',
  },
];

function ActivityCard({ activity, index }) {
  const [ref, inView] = useInView(0.15);
  return (
    <div
      ref={ref}
      className={`activity-card ${inView ? 'activity-card--visible' : ''}`}
      style={{ '--accent': activity.accent, transitionDelay: `${index * 0.08}s` }}
    >
      <div className="activity-card__icon">{activity.icon}</div>
      <div className="activity-card__body">
        <p className="activity-card__subtitle cinzel">{activity.subtitle}</p>
        <h3 className="activity-card__title cinzel">{activity.title}</h3>
        <p className="activity-card__desc">{activity.description}</p>
        <p className="activity-card__detail">{activity.detail}</p>
      </div>
      <div className="activity-card__accent-bar" />
    </div>
  );
}

export default function Activities() {
  const [ref, inView] = useInView(0.1);

  return (
    <section className="activities" id="activities" ref={ref}>
      <div className="section-container">
        <div className={`activities__header ${inView ? 'activities__header--visible' : ''}`}>
          <p className="activities__eyebrow cinzel">Sacred Offerings</p>
          <h2 className="activities__title cinzel">
            Activities &amp; <span className="activities__title-accent">Seva</span>
          </h2>
          <DiamondDivider color="#FF6B00" />
          <p className="activities__intro">
            Rooted in the Vedic tradition, our activities are acts of devotion — each one an
            offering to the Divine and a gift to the seekers who come to Arunachala.
          </p>
        </div>

        <div className="activities__grid">
          {activities.map((a, i) => (
            <ActivityCard key={a.title} activity={a} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
